import React from 'react';
import { spaNavigate, shouldIntercept } from '@/lib/spaNavigate';

// D26: the footer nudge on every Services screen and every plan.
export default function ServicesFooter({ className = '' }) {
  return (
    <p className={`mt-6 pt-4 border-t border-slate-100 dark:border-white/10 text-xs text-slate-500 dark:text-slate-400 ${className}`} data-testid="services-footer">
      Need more features? We recommend{' '}
      <a
        href="https://www.planningcenter.com/services"
        data-testid="services-footer-pco-link"
        target="_blank"
        rel="noopener noreferrer"
        className="text-teal-700 dark:text-teal-300 underline underline-offset-2"
      >
        Planning Center
      </a>{' '}
      with our{' '}
      <a
        href="/settings/planning-center"
        data-testid="services-footer-integration-link"
        onClick={(e) => {
          if (!shouldIntercept(e)) return;
          e.preventDefault();
          spaNavigate('/settings/planning-center');
        }}
        className="text-teal-700 dark:text-teal-300 underline underline-offset-2"
      >
        Planning Center integration
      </a>
      .
    </p>
  );
}
